export const SET_WEEKSTAAT_COUNT = "SET_WEEKSTAAT_COUNT";
export const SET_FEEDBACK_COUNT = "SET_FEEDBACK_COUNT";
export const RESET_MENU_COUNT = "RESET_MENU_COUNT";

export const SET_HOME_ITEM_COUNT = "SET_HOME_ITEM_COUNT";
export const RESET_VERVANGER_MENU_COUNT = "RESET_VERVANGER_MENU_COUNT";

export const setWeekstateCount = (weekstaatCount) => ({
    type: SET_WEEKSTAAT_COUNT,
    weekstaatCount,
});

export const setFeedbackCount = (feedbackCount) => ({
    type: SET_FEEDBACK_COUNT,
    feedbackCount,
});

export const setHomeItemCount = (homeItemCount) => ({
    type: SET_HOME_ITEM_COUNT,
    homeItemCount,
});

export const resetMenuCount = () => ({
    type: RESET_MENU_COUNT,
});

export const resetVervangerMenuCount = () => ({
    type: RESET_VERVANGER_MENU_COUNT,
});

const initialState = {
    weekstaatCount: 0,
    feedbackCount: 0,
    homeItemCount: 0,
};

export default function MenuCount(
    state = initialState,
    action
) {
    switch (action.type) {
        case SET_WEEKSTAAT_COUNT:
            return {
                ...state,
                weekstaatCount: action.weekstaatCount,
            };

        case SET_FEEDBACK_COUNT:
            return {
                ...state,
                feedbackCount: action.feedbackCount,
            };

        case SET_HOME_ITEM_COUNT:
            return {
                ...state,
                homeItemCount: action.homeItemCount,
            };

        case RESET_MENU_COUNT:
            return {
                ...state,
                weekstaatCount: 0,
                feedbackCount: 0,
            };

        case RESET_VERVANGER_MENU_COUNT:
            return {
                ...state,
                homeItemCount: 0,
            };

        default:
            return state;
    }
}